var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-title flex-between-center"},[_c('p',[_vm._t("default")],2),_c('div',[_vm._t("handle")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }